/* eslint-disable */
import React from "react";
import logoWhite from "../../assets/presentplus-logo-white.png";

export default function ParentLoadingScreen({ text = "Loading PresentPlus..." }) {
  return (
    <div style={styles.page}>
      <style>{`
        @keyframes ppPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.045); opacity: .92; }
        }

        @keyframes ppFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        @keyframes ppGlow {
          0%, 100% { opacity: .35; transform: scale(1); }
          50% { opacity: .65; transform: scale(1.12); }
        }

        @keyframes ppDot {
          0%, 80%, 100% { transform: scale(.72); opacity: .45; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <div style={styles.bgOrbOne} />
      <div style={styles.bgOrbTwo} />
      <div style={styles.glow} />

      <div style={styles.inner}>
        <div style={styles.logoShell}>
          <img src={logoWhite} alt="PresentPlus" style={styles.logo} />
        </div>

        <div style={styles.text}>{text}</div>

        <div style={styles.dots}>
          <span style={{ ...styles.dot, animationDelay: "0ms" }} />
          <span style={{ ...styles.dot, animationDelay: "160ms" }} />
          <span style={{ ...styles.dot, animationDelay: "320ms" }} />
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    display: "grid",
    placeItems: "center",
    background:
      "radial-gradient(circle at 30% 20%, rgba(112,150,255,.38), transparent 34%), linear-gradient(135deg,#083ea8 0%,#0f49bc 42%,#1538a7 100%)",
  },
  bgOrbOne: {
    position: "absolute",
    width: 360,
    height: 360,
    borderRadius: 999,
    background: "rgba(255,255,255,.10)",
    top: -90,
    right: -80,
    filter: "blur(2px)",
  },
  bgOrbTwo: {
    position: "absolute",
    width: 280,
    height: 280,
    borderRadius: 999,
    background: "rgba(107,123,255,.20)",
    bottom: -80,
    left: -70,
    filter: "blur(2px)",
  },
  glow: {
    position: "absolute",
    width: 260,
    height: 260,
    borderRadius: 999,
    background: "rgba(255,255,255,.18)",
    filter: "blur(38px)",
    animation: "ppGlow 2.7s ease-in-out infinite",
  },
  inner: {
    position: "relative",
    zIndex: 2,
    display: "grid",
    justifyItems: "center",
    gap: 18,
    animation: "ppFloat 3.2s ease-in-out infinite",
  },
  logoShell: {
    width: 132,
    height: 132,
    borderRadius: 36,
    display: "grid",
    placeItems: "center",
    background: "rgba(255,255,255,.12)",
    border: "1px solid rgba(255,255,255,.22)",
    boxShadow: "0 26px 70px rgba(0,0,0,.20)",
    backdropFilter: "blur(18px)",
    animation: "ppPulse 2.2s ease-in-out infinite",
  },
  logo: {
    width: 92,
    maxHeight: 92,
    objectFit: "contain",
  },
  text: {
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 800,
    letterSpacing: ".02em",
    opacity: 0.94,
  },
  dots: {
    display: "flex",
    gap: 8,
  },
  dot: {
    width: 9,
    height: 9,
    borderRadius: 999,
    background: "#ffffff",
    animation: "ppDot 1.2s ease-in-out infinite",
  },
};